export default __webpack_public_path__ + "static/pragicts-automation-banner-quality-9bb2a904978a21be99849011730d9189.jpg";